import { createAttrLinkedStore } from "src/components/AttrLinked/AttrLinkedStore";
import { ZAttrLabelsData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { ZAttribute } from "src/types/ZAttribute";
import { z } from "zod";
import { ZUid } from "src/types/zUid";

export const zAttrLinked = z.object({
  view: z.literal("AttrLinked"),
});
export type ZAttrLinked = z.infer<typeof zAttrLinked>;

export const makeAttrLinkedProps = (
  attibute: ZAttribute,
  ctx?: { entityId?: ZUid; labelsData?: ZAttrLabelsData },
) => {
  if (!ctx || !ctx.entityId || !ctx.labelsData) return { store: null };
  const store = createAttrLinkedStore(ctx.labelsData, ctx.entityId, attibute);
  return { store };
};
